import FilterActionTypes from "./filter-types.js";
import { selectTasksNameDropdownData, selectTasksProjectNameDropdownData, selectTasksMemberNameDropdownData } from "../tasks/task-utility";
import { selectProjectNameDropdownData, selectProjectMemberNameDropdownData, selectTagDropdownData } from "../projects/project-utility";
import { TaskActionTypes } from "../tasks/task-types";
import { ProjectActionTypes } from "../projects/project-types";

export const INITIAL_PROJECT_FILTER_DROPDOWN_STATE = [
  {
    filterType: 'Project',
    dropdownItems: [],
    usesDatePicker: false,
    placeholderText: 'Search and select project name(s)',
    projectDataField: 'Name',
    pluralizedName: "projects",
    isSearchable: true,
    isAdded: false
  },
  {
    filterType: 'Status',
    dropdownItems: [
      {
        id: 0,
        name: 'Active'
      },
      {
        id: 1,
        name: 'Completed'
      },
      {
        id: 2,
        name: 'Archived'
      },
    ],
    usesDatePicker: false,
    placeholderText: 'Select status',
    projectDataField: 'Status',
    pluralizedName: "statuses",
    isSearchable: false,
    isAdded: false
  },
  {
    filterType: 'Member',
    usesDatePicker: false,
    dropdownItems: [],
    placeholderText: 'Search and select member(s)',
    projectDataField: 'Members',
    isSearchable: true,
    isAdded: false
  },
  {
    filterType: 'Tags',
    usesDatePicker: false,
    dropdownItems: [],
    placeholderText: 'Search and select tag(s)',
    projectDataField: 'Tags',
    pluralizedName: "tags",
    isSearchable: true,
    isAdded: false
  },
  {
    filterType: 'Priority',
    usesDatePicker: false,
    dropdownItems: [
      {
        id: 0,
        name: 'Urgent'
      },
      {
        id: 1,
        name: 'High'
      },
      {
        id: 2,
        name: 'Medium'
      },
      {
        id: 3,
        name: 'Low'
      },
    ],
    placeholderText: 'Search and select priority',
    projectDataField: 'Priority',
    isSearchable: false,
    isAdded: false
  },
  {
    filterType: 'Start date',
    dropdownItems: [],
    usesDatePicker: true,
    placeholderText: 'Select a start date',
    projectDataField: 'Start',
    isSearchable: false,
    isAdded: false

  },
  {
    filterType: 'Due date',
    dropdownItems: [],
    usesDatePicker: true,
    placeholderText: 'Select a due date',
    projectDataField: 'End',
    isSearchable: false,
    isAdded: false
  }
]

export const INITIAL_TASK_FILTER_DROPDOWN_STATE = [
  {
    filterType: 'Task Type',
    dropdownItems: [
      {
        id: 0,
        docType: 1,
        name: 'Word Document'
      },
      {
        id: 0,
        docType: 2,
        name: 'Excel Document'
      },
      {
        id: 0,
        docType: 3,
        name: 'PowerPoint Document'
      },
      {
        id: 1,
        docType: 0,
        name: 'Standard Task'
      }
    ],
    usesDatePicker: false,
    placeholderText: 'Select task type(s)',
    taskDataField: ['TaskTypeId', 'DocumentTypeId'],
    isSearchable: false,
    isAdded: false,
    filterType2: "",
    usesDatePicker2: false,
    dropdownItems2: [],
    placeholderText2: "",
    taskDataField2: "",
    isAdded2: false
  },
  {
    filterType: 'Task Name',
    dropdownItems: [],
    usesDatePicker: false,
    placeholderText: 'Search and select task name(s)',
    taskDataField: 'Name',
    isSearchable: true,
    isAdded: false,
    filterType2: "",
    usesDatePicker2: false,
    dropdownItems2: [],
    placeholderText2: "",
    taskDataField2: "",
    isAdded2: false
  },
  {
    filterType: 'Project Name',
    dropdownItems: [],
    usesDatePicker: false,
    placeholderText: 'Search and select project name(s)',
    taskDataField: 'Project',
    pluralizedName: "projects",
    isSearchable: true,
    isAdded: false,
    filterType2: "",
    usesDatePicker2: false,
    dropdownItems2: [],
    placeholderText2: "",
    taskDataField2: "",
    isAdded2: false
  },
  {
    filterType: 'Priority',
    usesDatePicker: false,
    dropdownItems: [
      {
        id: 0,
        name: 'Urgent'
      },
      {
        id: 1,
        name: 'High'
      },
      {
        id: 2,
        name: 'Medium'
      },
      {
        id: 3,
        name: 'Low'
      },
    ],
    placeholderText: 'Search and select priority',
    taskDataField: 'Priority',
    isSearchable: false,
    isAdded: false,
    filterType2: "",
    usesDatePicker2: false,
    dropdownItems2: [],
    placeholderText2: "",
    taskDataField2: "",
    isAdded2: false
  },
  {
    filterType: 'Status',
    dropdownItems: [
      {
        id: 'Not Started Assigned Declined',
        name: 'Not Started'
      },
      {
        id: 'In Progress',
        name: 'In Progress'
      },
      {
        id: 'Awaiting Approval Pending review Assigned - Pending review',
        name: 'Pending Approval'
      },
      {
        id: 'Completed Approved',
        name: 'Completed'
      },
      {
        id: 'Overdue',
        name: 'Overdue'
      },
      {
        id: 'Cancelled',
        name: 'Cancelled'
      },
      {
        id: 'Archived',
        name: 'Archived'
      },
    ],
    usesDatePicker: false,
    placeholderText: 'Select status(es)',
    taskDataField: 'StatusAndButtons',
    pluralizedName: "statuses",
    isSearchable: false,
    isAdded: false,
    filterType2: "",
    usesDatePicker2: false,
    dropdownItems2: [],
    placeholderText2: "",
    taskDataField2: "",
    isAdded2: false
  },
  {
    filterType: 'Member',
    usesDatePicker: false,
    dropdownItems: [],
    placeholderText: 'Search and select member(s)',
    taskDataField: 'Members',
    isSearchable: true,
    isAdded: false,
    filterType2: 'Permission',
    usesDatePicker2: false,
    dropdownItems2: [
      {
        id: 'Owner (Approve) Owner (Edit) Owner (View) Owner',
        name: 'Owner'
      },
      {
        id: 'Creator',
        name: 'Creator'
      },
      {
        id: 'Approve',
        name: 'Approver'
      },
      {
        id: 'Edit',
        name: 'Editor'
      },
      {
        id: 'View',
        name: 'Viewer'
      },
    ],
    placeholderText2: 'Select permission(s)',
    taskDataField2: 'Permission',
    isAdded2: false
  },
  {
    filterType: 'Start date',
    dropdownItems: [],
    usesDatePicker: true,
    placeholderText: 'Select a start date',
    taskDataField: 'Start',
    isSearchable: false,
    isAdded: false,
    filterType2: "",
    usesDatePicker2: false,
    dropdownItems2: [],
    placeholderText2: "",
    taskDataField2: "",
    isAdded2: false
  },
  {
    filterType: 'Due date',
    dropdownItems: [],
    usesDatePicker: true,
    placeholderText: 'Select a due date',
    taskDataField: 'Due',
    isSearchable: false,
    isAdded: false,
    filterType2: "",
    usesDatePicker2: false,
    dropdownItems2: [],
    placeholderText2: "",
    taskDataField2: "",
    isAdded2: false
  }
]

export const INITIAL_STATE = {
  projects: {
    conjunctionSelection: { name: "And", id: 0 },
    appliedFilters: [],
    totalFilterOptions: INITIAL_PROJECT_FILTER_DROPDOWN_STATE,
  },
  tasks: {
    conjunctionSelection: { name: "And", id: 0 },
    appliedFilters: [],
    totalFilterOptions: INITIAL_TASK_FILTER_DROPDOWN_STATE,
  }
}

const filterReducer = (state = INITIAL_STATE, { type, payload, labels }) => {
  switch (type) {

    // PROJECTS
    case FilterActionTypes.UPDATE_PROJECTS_FILTER_APPLIED:
      return {
        ...state,
        projects: {
          ...state.projects,
          appliedFilters: payload
        }
      }
    case FilterActionTypes.UPDATE_PROJECTS_FILTER_OPTIONS_TOTAL:
      return {
        ...state,
        projects: {
          ...state.projects,
          totalFilterOptions: payload
        }
      }
    case FilterActionTypes.UPDATE_PROJECTS_FILTER_CONJUNCTION_SELECTION:
      return {
        ...state,
        projects: {
          ...state.projects,
          conjunctionSelection: payload
        }
      }


    // TASKS
    case FilterActionTypes.UPDATE_TASKS_FILTER_APPLIED:
      return {
        ...state,
        tasks: {
          ...state.tasks,
          appliedFilters: payload
        }
      }
    case FilterActionTypes.UPDATE_TASKS_FILTER_OPTIONS_TOTAL:
      return {
        ...state,
        tasks: {
          ...state.tasks,
          totalFilterOptions: payload
        }
      }
    case FilterActionTypes.UPDATE_TASKS_FILTER_CONJUNCTION_SELECTION:
      return {
        ...state,
        tasks: {
          ...state.tasks,
          conjunctionSelection: payload
        }
      }

    //Reducers to add dropdown data for filter button in task page
    case TaskActionTypes.SET_TASKS:
      return {
        ...state,
        tasks: {
          ...state.tasks,
          totalFilterOptions: state.tasks.totalFilterOptions.map((filter) => {
            const filterCopy = { ...filter };
            if (filter.filterType === 'Member') {
              const dropdownItems = selectTasksMemberNameDropdownData(payload);
              filterCopy.dropdownItems = dropdownItems;
            } else if (filter.filterType === 'Task Name') {
              const dropdownItems = selectTasksNameDropdownData(payload);
              filterCopy.dropdownItems = dropdownItems;
            }
            return filterCopy;
          })
        }
      }
    case TaskActionTypes.SET_TASK_COUNT_AND_PROJECT_LIST:
      return {
        ...state,
        tasks: {
          ...state.tasks,
          totalFilterOptions: state.tasks.totalFilterOptions.map((filter) => {
            const filterCopy = { ...filter };
            if (filter.filterType === 'Project Name') {
              const dropdownItems = selectTasksProjectNameDropdownData(payload.projects);
              filterCopy.dropdownItems = dropdownItems;
            }
            return filterCopy;
          })
        }
      }

    //Reducers to add dropdown data for filter button in project page
    case ProjectActionTypes.SET_PROJECTS:
      
      return {
        ...state,
        projects: {
          ...state.projects,
          totalFilterOptions: state.projects.totalFilterOptions.map((filter) => {
            const labelsObjects = labels;
            const filterCopy = { ...filter };
            if (filter.filterType === 'Project') {
              filterCopy.filterType = labelsObjects?.ProjectSingular || 'Project';
              filterCopy.placeholderText = `Search and select ${labelsObjects?.ProjectSingular?.toLowerCase() || 'project'} name(s)`;
              const dropdownItems = selectProjectNameDropdownData(payload);
              filterCopy.dropdownItems = dropdownItems;
            } else if (filter.filterType === 'Member') {
              const dropdownItems = selectProjectMemberNameDropdownData(payload);
              filterCopy.dropdownItems = dropdownItems;
            } else if (filter.filterType === 'Tags') {
              const dropdownItems = selectTagDropdownData(payload);
              filterCopy.dropdownItems = dropdownItems;
            }
            return filterCopy;
          })
        }
      }

    // UNIVERSAL CLEAR FILTER
    case FilterActionTypes.CLEAR_ALL_FILTERS:
      return INITIAL_STATE;

    default:
      return state;
  }
}

export default filterReducer;
